import { AT_COLORS } from '../../shared/design-system/tokens';

type ATSection = 'hub' | 'hesh' | 'pricing-committee';

// ─── Feature item ───────────────────────────────────────────────────────────

export interface ATConsoleFeature {
  name: string;
  description: string;
  comingSoon?: boolean;
}

// ─── Console card config ────────────────────────────────────────────────────

export interface ATConsoleConfig {
  id: Exclude<ATSection, 'hub'>;
  accent: string;
  accentDim: string;
  statusLabel: string;
  metricLabel: string;
  name: string;
  tagline: string;
  features: ATConsoleFeature[];
  enterLabel: string;
  /** Si true, el botón de entrada queda deshabilitado (consola aún no disponible en este env). */
  disabled?: boolean;
  /** Si true, la card no se muestra en el Hub (consola pendiente de definición formal). */
  hidden?: boolean;
}

// ─── Consoles ───────────────────────────────────────────────────────────────

export const AT_CONSOLES: ATConsoleConfig[] = [
  {
    id:          'hesh',
    accent:      AT_COLORS.teal,
    accentDim:   AT_COLORS.tealDim,
    statusLabel: 'En vivo',
    metricLabel: '· 23 decisiones/min',
    name:        'HeSH Console',
    tagline:
      'Motor de decisiones en tiempo real. Ajusta parámetros del algoritmo, ' +
      'visualiza el flujo live y diagnostica cada decisión del pipeline.',
    features: [
      { name: 'The Booth', description: 'Decisiones en tiempo real' },
      { name: 'The Mixer', description: 'Parámetros del algoritmo'  },
      { name: 'The Trace', description: 'Inspector de decisiones'   },
      { name: 'The Drop',  description: 'Alertas y anomalías'       },
    ],
    enterLabel: 'Abrir consola',
    hidden: true,
  },
  {
    id:          'pricing-committee',
    accent:      AT_COLORS.amber,
    accentDim:   AT_COLORS.amberDim,
    statusLabel: 'Activo',
    metricLabel: '· 1,589 NIDs · CO',
    name:        'Pricing Committee',
    tagline:
      'Observabilidad completa del pipeline de valoración. ' +
      'Revisa el detalle de cualquier NID, inspecciona comparables en el mapa ' +
      'y analiza la escalera de metafiltros.',
    features: [
      { name: 'Dashboard',       description: 'Métricas del pipeline CO/MX'  },
      { name: 'Detalle del NID', description: 'Mapa, comparables y escalera' },
      { name: 'Destrabe',        description: 'Intervención con trazabilidad', comingSoon: true },
    ],
    enterLabel: 'Abrir consola',
    disabled: true,
  },
];
